import script from "./HomeHeading.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeHeading.vue?vue&type=script&lang=ts&setup=true"

import "./HomeHeading.vue?vue&type=style&index=0&id=3dee7d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dee7d4a"]])

export default __exports__